import { appWithTheme } from '@scorenco/components';
import {
  ApolloService,
  AmplifyService,
  SentryService,
  useTranslation,
} from '@scorenco/core';
import { AppLayout, NextI18nService, AppPropsWithLayout } from '@scorenco/next';
import Head from 'next/head';
import type { AppProps } from 'next/app';

import { T_KEYS } from '@/translations';

AmplifyService.init();

NextI18nService.init({
  i18n: {
    defaultLocale: 'fr',
    locales: ['fr' /*'de'*/],
  },
  ns: ['snc-components', 'snc-core', 'common'],
  fallbackLng: ['fr' /*'de'*/],
});

const App = (appProps: AppProps) => {
  const layoutProps = appProps as AppPropsWithLayout;
  const { pageProps } = appProps;
  const { t } = useTranslation();

  return (
    <SentryService>
      <ApolloService initialApolloState={pageProps.initialApolloState}>
        <AmplifyService>
          <Head>
            <title>{t(T_KEYS.DEFAULT_HTML_TITLE)}</title>
          </Head>
          <AppLayout {...layoutProps} />
        </AmplifyService>
      </ApolloService>
    </SentryService>
  );
};

export default appWithTheme(NextI18nService.appEnhancer(App));
